import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationItem } from '../../../models/common';
import { ResponsiveService } from '../../../services/responsive/responsive.service';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { Utilities } from '../../../utilities/utilities.helper';

/**
 * @export
 * @class LsqBannerTabsComponent
 * @implements {OnInit}
 * @property {Observable<NavigationItem[]>} navigationItemsStream Routes to tab to
 * @property {boolean} [noPadding]
 */
@Component({
    selector: 'lsq-banner-tabs',
    template: `
        <div class="lsq-banner-tabs" *ngIf="!(isMobile$ | async)">
            <ul class="nav">
                <ng-container
                    *ngFor="let navigationItem of navigationItemsStream | async; let i = index"
                >
                    <ng-container *ngIf="(isLoggedIn$ | async) || navigationItem.allowAnonymous">
                        <ng-container *featureFlag="navigationItem.featureFlags">
                            <ng-container *environments="navigationItem.environments">
                                <li
                                    *claimsOr="navigationItem.claims"
                                    class="nav-item"
                                    routerLinkActive="active selected"
                                    [routerLink]="navigationItem.routerLink"
                                    [ngStyle]="{
                                        width: 100 / (navigationItemsStream | async).length + '%'
                                    }"
                                >
                                    <span class="nav-link active">{{ navigationItem.label }}</span>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>

        <div #mobileTabsContainer class="lsq-banner-tabs-mobile" *ngIf="isMobile$ | async">
            <ul class="nav">
                <ng-container
                    *ngFor="let navigationItem of navigationItemsStream | async; let i = index"
                >
                    <ng-container *ngIf="(isLoggedIn$ | async) || navigationItem.allowAnonymous">
                        <ng-container *featureFlag="navigationItem.featureFlags">
                            <ng-container *environments="navigationItem.environments">
                                <li
                                    *claimsOr="navigationItem.claims"
                                    class="nav-item"
                                    routerLinkActive="active selected"
                                    (click)="scrollToTab()"
                                    [routerLink]="navigationItem.routerLink"
                                >
                                    <span class="nav-link active">{{ navigationItem.label }}</span>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
    `,
    styleUrls: ['./lsq-banner-tabs.component.scss']
})
export class LsqBannerTabsComponent {
    @Input() public navigationItemsStream: Observable<NavigationItem[]>;
    @Input() public noPadding?: boolean;
    @ViewChild('mobileTabsContainer') public mobileTabsContainer: ElementRef;

    public isMobile$ = this.responsiveService.smBelow;
    public isLoggedIn$ = this._userService.isLoggedIn$;

    constructor(private responsiveService: ResponsiveService, private _userService: UserService) {}

    public scrollToTab(): void {
        Utilities.executeAfterRender(() => {
            if (
                this.mobileTabsContainer &&
                this.mobileTabsContainer.nativeElement &&
                this.mobileTabsContainer.nativeElement.querySelector(
                    '.lsq-banner-tabs-mobile .selected'
                )
            ) {
                const selectedItemBoundingRect = this.mobileTabsContainer.nativeElement
                    .querySelector('.lsq-banner-tabs-mobile .selected')
                    .getBoundingClientRect();
                const tabsContainer = this.mobileTabsContainer.nativeElement;
                const tabsContainerWidth = tabsContainer.getBoundingClientRect().width;
                const tabsContainerScrollLeft = tabsContainer.scrollLeft;
                const scrollExtraSpace = 20;

                if (
                    selectedItemBoundingRect.left + selectedItemBoundingRect.width >
                    tabsContainerWidth - scrollExtraSpace
                ) {
                    const scrollAdd =
                        selectedItemBoundingRect.left +
                        selectedItemBoundingRect.width -
                        (tabsContainerWidth - scrollExtraSpace);
                    tabsContainer.scrollLeft = tabsContainerScrollLeft + scrollAdd;
                }

                if (selectedItemBoundingRect.left - scrollExtraSpace < 0) {
                    const scrollSubtract = -1 * (selectedItemBoundingRect.left - scrollExtraSpace);
                    tabsContainer.scrollLeft = tabsContainerScrollLeft - scrollSubtract;
                }
            }
        });
    }
}
